export default () => (
  /**
   * Icone de um folha.
   * Geralmente utilizada para docs.
   */
  <svg
    width="18"
    height="24"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6975 4.69386L12.5668 0.563149C12.2246 0.22096 11.7846 0.0498657 11.3202 0.0498657H2.39887C1.17677 0.0498657 0.174644 1.05199 0.174644 2.2741V20.8256C0.174644 22.0477 1.17677 23.0499 2.39887 23.0499H14.9865C16.2086 23.0499 17.2108 22.0477 17.2108 20.8256V5.94041C17.2108 5.47601 17.0397 5.03605 16.6975 4.69386ZM15.6954 5.42712H12.9579C12.2246 5.42712 11.638 4.84051 11.638 4.10725V1.36974C11.6624 1.39418 11.6869 1.39418 11.7113 1.41862L15.6954 5.42712ZM15.011 21.8033H2.39887C1.86115 21.8033 1.39675 21.3634 1.39675 20.8012V2.2741C1.42119 1.71193 1.86115 1.27197 2.39887 1.27197H10.4159V4.10725C10.4159 5.52489 11.5402 6.64923 12.9579 6.64923H16.0131V20.8012C15.9887 21.3634 15.5487 21.8033 15.011 21.8033ZM13.5933 12.3931H3.81651C3.47433 12.3931 3.20546 12.1243 3.20546 11.7821C3.20546 11.4399 3.47433 11.171 3.81651 11.171H13.5933C13.9355 11.171 14.2044 11.4399 14.2044 11.7821C14.2044 12.1243 13.9355 12.3931 13.5933 12.3931ZM13.5933 15.204H3.81651C3.47433 15.204 3.20546 14.9351 3.20546 14.5929C3.20546 14.2507 3.47433 13.9819 3.81651 13.9819H13.5933C13.9355 13.9819 14.2044 14.2507 14.2044 14.5929C14.2044 14.9351 13.9355 15.204 13.5933 15.204ZM13.5933 18.0148H3.81651C3.47433 18.0148 3.20546 17.7459 3.20546 17.4037C3.20546 17.0616 3.47433 16.7927 3.81651 16.7927H13.5933C13.9355 16.7927 14.2044 17.0616 14.2044 17.4037C14.2044 17.7459 13.9355 18.0148 13.5933 18.0148Z"
      fill="white"
    />
    <rect
      x="3.20953"
      y="8.22455"
      width="6.25728"
      height="1.20554"
      rx="0.60277"
      fill="white"
    />
  </svg>
);
